import React from 'react';
import { IconHighlight, Typography, Button } from '@ann/web-components';
import { EmptyStateWrapper, EmptyStateContent, TitleBlock } from './ContactsEmptyState.styled';

const ContactsEmptyState = ({ onCreateContact }) => (
  <EmptyStateWrapper>
    <EmptyStateContent>
      <IconHighlight
        icon="personAdd"
        bgColor="Primary"
        iconColor="Primary"
        size="large"
      />
      <TitleBlock>
        <Typography
          category="title"
          size="medium"
          weight="bold"
          color="title"
        >
          Start by adding your first contact
        </Typography>
        <Typography
          category="body"
          size="medium"
          weight="regular"
          color="body"
        >
          Start by adding your first contact
        </Typography>
      </TitleBlock>
      <Button
        label="Create contact"
        iconLeft="plus"
        type="primary"
        size="medium"
        onClick={onCreateContact}
        disabled
      />
    </EmptyStateContent>
  </EmptyStateWrapper>
);

export default ContactsEmptyState;
